import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const Hr = styled.div`
  width: ${({width}) => width};
  height: 1px;
  background: #e5e5e5;
`;
